// extracted by mini-css-extract-plugin
export var welcome = "ProWelcome-module__welcome___LqB2v";
export var content = "ProWelcome-module__content___Uckq0";
export var btn = "ProWelcome-module__btn___sbBRt";
export var img = "ProWelcome-module__img___MHtH4";
export var mobileBadge = "ProWelcome-module__mobileBadge___rXYLs";
export var desktopBadge = "ProWelcome-module__desktopBadge____fM4U";